/**
 * TtfLongHorMetric.ts class for EJ2-PDF
 */
export class TtfLongHorMetric {
}
